import { render, staticRenderFns } from "./RiskAnalysisQuotator.vue?vue&type=template&id=00ac1321&scoped=true&"
import script from "./RiskAnalysisQuotator.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisQuotator.vue?vue&type=script&lang=js&"
import style0 from "./RiskAnalysisQuotator.vue?vue&type=style&index=0&id=00ac1321&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac1321",
  null
  
)

export default component.exports